import type { Dict } from './index';

// İspanyolca sözlük — Claude tarafından elle çevrildi (06.08.2026), makine
// çevirisi kullanılmadı. en.ts ile aynı yapıda olmalı (tip zorunlu kılar).
export const es: Dict = {
  signInMethods: {
    // D-871 — the linked Google accounts, and removing one.
    googleAccountUnknown: "Cuenta de Google (dirección aún desconocida)",
    googleLinkedDate: "Vinculada el {date}",
    googleRemove: "Eliminar",
    googleRemoveTitle: "¿Eliminar esta cuenta de Google?",
    googleRemoveBody: "Primero confirmarás tu número registrado. Después, esta cuenta de Google ya no podrá iniciar sesión en nosubject.",
    googleRemoveConfirm: "Introduce el código para eliminar {account}.",
    googleRemoved: "Cuenta de Google eliminada.",
    googleLastMethod: "Es la única forma de iniciar sesión en esta cuenta, así que no se puede eliminar.",
    googleAddAnother: "Vincular otra cuenta de Google",
    googleLinkedCount: "Cuentas de Google vinculadas: {count}",
    googleLinked: "Cuenta de Google vinculada.",
    googleCodeSent: "Se envió un código a tu número registrado terminado en {phone}.",
    googleChooseHint: "La cuenta de Google que elijas se vinculará para iniciar sesión en esta cuenta de nosubject.",
    googleStatusUnknown: "No se pudo comprobar el estado de la conexión con Google. Vuelve a comprobarlo.",
    googleLinkIntro: "Verifica el teléfono registrado en esta cuenta antes de vincular Google.",
    googleLinkFailed: "No se pudo completar la solicitud. Inténtalo de nuevo.",
    googleSendCode: "Enviar código de verificación",
    googleCodeLabel: "Código de verificación",
    googleStartAgain: "Empezar de nuevo",
    googleContinue: "Continuar con Google",
    googleFailed: "No se pudo completar el inicio de sesión con Google. Inténtalo de nuevo.",
    googleNotLinked: "Esta cuenta de Google aún no está vinculada a una cuenta de nosubject.",
    googleUnavailable: "El inicio de sesión con Google aún no está disponible.",
    title: "Métodos de inicio de sesión",
    intro: "Esta sección está en preparación. Más adelante se añadirán opciones para gestionar los métodos de inicio de sesión.",
    identity: "Verificación de identidad",
    identityInfo: "Verificar tu identidad es un proceso distinto de iniciar sesión en tu cuenta.",
  },
  safety: {
    title: 'Número de seguridad',
    compare: 'Compara este número con {name}. Si coincide, nadie puede interponerse y leer los mensajes.',
    explainInfo: 'El número se calcula con las claves de cifrado de todos los dispositivos actuales de ambos y es el mismo en los dos teléfonos. Si alguno añade un dispositivo, como un teléfono nuevo o la web, el número cambia; entonces compáralo de nuevo. La verificación se guarda solo en este dispositivo.',
    qrLabel: 'Código QR del número de seguridad',
    verified: 'Verificado',
    notVerified: 'Sin verificar',
    markVerified: 'Marcar como verificado',
    clearVerified: 'Quitar verificación',
    peerUnavailable: 'El cifrado aún no está activo con esta persona.',
    selfUnavailable: 'La clave de cifrado de este dispositivo aún no está lista.',
    loadFailed: 'No se pudo cargar el número de seguridad.',
  },
  backup: {
    title: 'Copia del chat',
    explainInfo: 'Tu historial vive en este dispositivo. La copia lo cifra con tu código de recuperación y lo guarda en el servidor; no podemos abrirla.',
    create: 'Crear copia',
    refresh: 'Actualizar copia',
    codeTitle: 'Tu código de recuperación',
    codeWarning: 'Guarda este código en un lugar seguro. Si lo pierdes tu historial no vuelve, y nosotros tampoco podemos abrirlo.',
    restoreTitle: 'Restaurar historial',
    restorePlaceholder: 'Código de recuperación',
    restore: 'Restaurar',
    restored: '{count} mensajes restaurados.',
    restoreFailed: 'No se pudo abrir el historial. Revisa el código.',
    failed: 'No se pudo crear la copia.',
  },
  common: {
    clear: "Borrar búsqueda",
    infoHide: 'Ocultar explicación: {subject}',
    infoShow: 'Mostrar explicación: {subject}',
    continue: 'Continuar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    save: 'Guardar',
    done: 'Listo',
    retry: 'Reintentar',
    error: 'Error',
    back: 'Atrás',
    search: 'Buscar…',
    loading: 'Cargando',
    remove: 'Quitar',
    offline: 'No se puede conectar al servidor. Revisa tu conexión.',
    sessionExpired: 'Tu sesión terminó. Inicia sesión de nuevo.',
    tooManyRequests: 'Demasiadas solicitudes. Espera un poco e inténtalo de nuevo.',
  },
  time: {
    now: 'ahora',
    minAgo: 'hace {n} min',
    hourAgo: 'hace {n} h',
    yesterday: 'ayer',
    dayAgo: 'hace {n} días',
    weekAgo: 'hace {n} semanas',
    weekAgoOne: 'hace {n} semana',
    today: 'Hoy',
    dayYesterday: 'Ayer',
  },
  phone: {
    sendFailed: "No se pudo enviar el código. Inténtalo de nuevo.",
    subtitle: 'Introduce tu número de teléfono',
    selectCountry: 'País / región',
    countrySearch: 'Buscar país…',
    architectureLink: 'Arquitectura técnica y hoja de ruta ↗',

  },
  otp: {
    verifyFailed: "No se pudo verificar el código. Inténtalo de nuevo.",
    invalidCode: "El código no es válido o ha caducado.",
    rateLimited: "Demasiados intentos. Inténtalo de nuevo más tarde.",
    title: 'Introduce el código',
    sentTo: 'Enviamos un SMS a {phone}',
    verify: 'Verificar',
    resend: 'Reenviar',

    tooManyAttempts: 'Demasiados intentos. Espera un poco e inténtalo de nuevo.',

    resendSent: 'Se envió un código nuevo.',
    resendFailed: 'No se pudo enviar el código. Revisa tu conexión e inténtalo de nuevo.',
    resendWait: 'Puedes pedirlo otra vez en {n} s',
  },
  university: {
    title: '¿Cuál es tu universidad?',
    subtitle: 'Busca tu universidad',
    placeholder: 'Harvard, Oxford…',
    skip: 'Omitir',
  },
  profession: {
    title: '¿A qué te dedicas?',
    subtitle: 'Busca tu profesión',
    placeholder: 'Profesor, desarrollador, enfermero…',
    skip: 'Omitir',
  },
  isco: {
    '0': 'Fuerzas armadas',
    '1': 'Directores y gerentes',
    '2': 'Profesionales científicos e intelectuales',
    '3': 'Técnicos y profesionales de nivel medio',
    '4': 'Personal de apoyo administrativo',
    '5': 'Trabajadores de los servicios y vendedores',
    '6': 'Agricultores y trabajadores agropecuarios, forestales y pesqueros',
    '7': 'Oficiales, operarios y artesanos',
    '8': 'Operadores de instalaciones y máquinas',
    '9': 'Ocupaciones elementales',
  },
  isced: {
    '5': 'Grado técnico',
    '6': 'Licenciatura',
    '7': 'Máster',
    '8': 'Doctorado',
  },
  profileCreate: {
    photoPickerFailed: "No se pudo abrir la biblioteca de fotos.",
    title: 'Crea tu perfil',
    addPhoto: 'Añadir foto',
    name: 'Tu nombre',
    surname: 'Tu apellido',
  },
  terms: {
    title: 'Antes de empezar',
    age: 'Soy mayor de 18 años',
    accept: 'He leído y acepto los Términos de Servicio y la Política de Privacidad',
    termsLink: 'Términos de Servicio',
    privacyLink: 'Política de Privacidad',
    continue: 'Aceptar y continuar',
    saveFailed: 'No se pudo guardar tu consentimiento. Revisa tu conexión e inténtalo de nuevo.',
    docPlaceholder: 'Este documento se publicará pronto.',
  },
  locationConsent: {
    title: 'Tu ubicación, solo si tú quieres',
    body: 'Necesitamos permiso de ubicación para sugerir el distrito y la ciudad cuando hagas una foto.',
    privacy: 'Este paso no consulta tu ubicación. Solo se usa después de hacer una foto correctamente y no guardamos tus coordenadas exactas. Puedes cambiar el permiso más adelante en los ajustes del dispositivo.',
    allow: 'Permitir ubicación',
    later: 'Ahora no',
  },
  discover: {
    title: "Descubrir",
    categories: "Categorías profesionales",
    categoryHint: "Descubre personas según las profesiones que comparten en sus perfiles.",
    all: "Todas",
    reset: "Borrar filtros",
    failed: 'No se pudo cargar',
    free: 'Gratis',
    empty: 'Todavía no hay nadie',
  },
  userProfile: {
    smsVerifiedOn: "Teléfono verificado por SMS · {date}",
    googleLinkedOn: "Cuenta de Google vinculada · {date}",
    contactProofNote: "Confirma el acceso a un teléfono o una cuenta de Google, no la identidad de una persona.",
    failed: 'No se pudo cargar el perfil',
    sendMessage: 'Enviar mensaje',
    buyTime: 'Proponer un encuentro',
    block: 'Bloquear',
    blockedNotice: '{name} está bloqueado. Mensajes, llamadas y encuentros desactivados.',
    blockTitle: '¿Bloquear a {name}?',
    blockMessage: 'Esta persona no podrá enviarte mensajes ni encontrarte en Descubrir.',
    blockConfirm: 'Bloquear',
  },
  callHistory: {
    empty: 'Aún no hay llamadas',
    tabAll: 'Todas',
    tabMissed: 'Perdidas',
    emptyMissed: 'No hay llamadas perdidas',
    failed: 'No se pudieron cargar las llamadas',
    outgoing: 'Saliente',
    incoming: 'Entrante',
    missed: 'Perdida',
    declined: 'Rechazada',
    cancelled: 'Cancelada',
  },
  call: {
    title: 'Llamada de voz',
    calling: 'Llamando…',
    incoming: 'Llamada entrante',
    connecting: 'Conectando…',
    connected: 'Conectado',
    reconnecting: 'Reconectando…',
    logAnswered: 'Llamada de voz',
    logAnsweredVideo: 'Videollamada',
    logNoAnswer: 'Sin respuesta',
    logMissed: 'Llamada perdida',
    logDeclined: 'Llamada rechazada',
    logYouDeclined: 'Rechazaste la llamada',
    logCancelled: 'Llamada cancelada',
    ended: 'Llamada finalizada',
    accept: 'Responder',
    decline: 'Rechazar',
    hangUp: 'Colgar',
    close: 'Cerrar',
    mute: 'Desactivar micrófono',
    unmute: 'Activar micrófono',
    cameraOff: 'Apagar cámara',
    cameraOn: 'Encender cámara',
    flipCamera: 'Cambiar cámara',
    audioOutput: 'Salida de audio: {route}',
    audioOutputTitle: 'Elige la salida de audio',
    earpiece: 'Auricular',
    speaker: 'Altavoz',
    bluetooth: 'Bluetooth',
    bluetoothPermissionDenied: 'El permiso de Bluetooth está desactivado. Actívalo en Ajustes.',
    micPermission: 'Las llamadas necesitan acceso al micrófono. Actívalo en Ajustes.',
    micPermissionWeb: 'Las llamadas necesitan acceso al micrófono. Permítelo en la configuración del sitio de tu navegador.',
    wiredHeadset: 'Auriculares con cable',
    audioRouteFailed: 'No se pudo cambiar la salida de audio',
    acceptFailed: 'No se pudo contestar la llamada. Inténtalo de nuevo.',
    declineFailed: 'No se pudo rechazar la llamada. Inténtalo de nuevo.',
    endFailed: 'No se pudo finalizar la llamada. Inténtalo de nuevo.',
    mediaConnectionFailed: 'No se pudo establecer la conexión de audio. La llamada terminó sin coste.',
    remaining: 'Quedan {time}',
    endingSoon: 'Esta llamada terminará pronto.',
    spent: '{amount} gastado',
    earned: '{amount} ganado',
    noAudioNotice: 'Esta versión aún no transmite audio. Se están probando el flujo de las llamadas y el cobro.',
    failed: 'No se pudo iniciar la llamada',
    insufficient: 'Tu saldo no alcanza para esta llamada',
    busy: 'La otra persona está ocupada',
    notAllowed: 'Antes de llamar, debe haber al menos un mensaje entre tú y esta persona',
    notAccepting: 'Esta persona no acepta llamadas ahora mismo',
    priceFree: 'Gratis',
    priceChanged: 'La tarifa de llamada cambió. Mira la nueva tarifa e inténtalo de nuevo.',
    rateLimited: 'Has realizado demasiados intentos de llamada. Espera un poco y vuelve a intentarlo.',
    reservationLinkUnavailable: 'Esta reserva ya no se puede vincular a la llamada. Puedes iniciar una llamada normal en su lugar.',
    missed: 'Llamada perdida',
    callNow: 'Llamar ahora',
    videoNow: 'Videollamada ahora',
    scheduledStartTitle: 'Llamada programada',
    scheduledStartBody: 'Tu llamada programada con {name} está empezando. ¿Llamar ahora?',
    schedule: 'Programar una llamada',
    scheduleTitle: 'Programar una llamada con {name}',
    subjectPlaceholder: 'Asunto (opcional)',
    priceNote: 'Tarifa de llamada: {price}',
    sendReservation: 'Enviar solicitud de reserva',
    reservationSent: 'Solicitud enviada',
    reservationSentBody: 'Tu solicitud de reserva de llamada se envió a {name}.',
    reservationFailed: 'No se pudo enviar la solicitud de reserva de llamada',
    reservationBubble: '☎️ Reserva de llamada solicitada',
    reservationBubbleShort: '☎️ Reserva de llamada',
    reservationLabel: 'Reserva de llamada de voz',
    rescheduleBubble: '☎️ Se propuso una nueva hora de llamada',
    rescheduleBubbleShort: '☎️ Nueva hora de llamada',
  },
  wallet: {
    otherAmount: "Otro",
    customAmount: "Importe",
    customAmountHint: "Hasta {amount}; como máximo dos decimales.",
    title: 'Cartera',
    failed: 'No se pudo cargar la cartera',
    availableBalance: 'Saldo disponible',
    earningsTitle: 'Mis ganancias',
    earningsTotal: 'Total ganado',
    earningsWithdrawable: 'Disponible para retirar',
    earningsEscrow: 'En garantía',
    addFunds: 'Añadir fondos',
    addFundsDemo: 'Demo: añade saldo de prueba a tu cuenta',
    addFundsFailed: 'No se pudieron añadir fondos.',
    topupLabel: 'Fondos añadidos',
    transactions: 'Transacciones',
    noTransactions: 'Aún no hay transacciones',
    waiting: 'pendiente',
    incomingRequest: 'solicitud entrante',
    replied: 'respondido',
    earned: 'ganado',
    refunded: 'Reembolsado',
    requestPayout: 'Retirar',
    payoutHint: 'Puedes retirar hasta {amount}.',
    payoutAll: 'Seleccionar el importe total',
    payoutRequested: 'Solicitud recibida',
    payoutRequestedBody: 'Se ha creado una solicitud de retiro de {amount} y se procesará pronto.',
    payoutFailed: 'No se pudo crear la solicitud de retiro',
    payoutRequests: 'Solicitudes de retiro',
    noPayouts: 'Aún no hay solicitudes de retiro',
    payoutStatusPending: 'Pendiente',
    payoutStatusPaid: 'Pagado',
    payoutStatusRejected: 'Rechazado',
    paymentAccount: 'Cuenta de pago',
    stripeConnect: 'Conectar cuenta de pago',
    stripeConnectInfo: 'Vincula tu cuenta bancaria para recibir tus ganancias (Stripe, modo de prueba)',
    stripeConnected: 'Conectada',
    stripeConnectFailed: 'No se pudo conectar',
  },
  calendar: {
    dateInputLabel: "Fecha",
    timeInputLabel: "Hora",
    dateInputHint: "Introduce el año, el mes y el día en formato YYYY-MM-DD.",
    timeInputHint: "Introduce la hora en formato de 24 horas: HH:MM.",

    previousWeek: 'Semana anterior',
    nextWeek: 'Semana siguiente',
    empty: 'No hay solicitudes que mostrar',
    failed: 'No se pudo cargar el calendario',
    statusPending: 'Pendiente',
    statusAccepted: 'Aceptado',
    statusDeclined: 'Rechazado',
    statusCancelled: 'Cancelado',
    statusExpired: 'Caducado',
    accept: 'Aceptar',
    decline: 'Rechazar',
    cancel: 'Cancelar',
    cancelConfirmationTitle: '¿Cancelar esta reserva?',
    cancelConfirmationAcceptedBody: 'La reserva confirmada con {name} se cancelará. La otra persona recibirá una notificación y la acción no se podrá deshacer.',
    cancelConfirmationPendingBody: 'La propuesta enviada a {name} se retirará. La otra persona recibirá una notificación y la acción no se podrá deshacer.',
    actionFailed: 'La acción falló',
    proposeTitle: 'Proponer un encuentro con {name}',
    locationPlaceholder: '¿Dónde? (opcional)',
    sendProposal: 'Enviar propuesta',
    proposalSent: 'Propuesta enviada',
    proposalSentBody: 'Tu propuesta de encuentro fue enviada a {name}.',
    priceChangedBody: 'La tarifa por minuto de esta reserva ahora es {amount}. No se creó ninguna propuesta: revisa la nueva tarifa y envía una nueva propuesta.',
    proposalFailed: 'No se pudo enviar la propuesta',
    meetupBubble: '📅 Encuentro propuesto',
    meetupBubbleShort: '📅 Propuesta de encuentro',
    proposeAction: '📅 Proponer un encuentro',
    priceNote: 'Tarifa del encuentro: {price}',
    totalCost: 'Total: {amount}',
    minutesShort: 'min',
    tabRequests: 'Solicitudes',
    tabCalendar: 'Calendario',
    tabActive: 'Actuales',
    tabHistory: 'Historial',
    loadMore: 'Ver más',
    noEventsForDay: 'No hay eventos este día',
    meetupLabel: 'Encuentro presencial',
    reservationDetails: 'Detalles de la reserva',
    reservationParticipant: 'Persona',
    reservationHeld: 'La llamada se realizó',
    reservationNotHeld: 'No se realizó ninguna llamada',
    reservationDateTime: 'Fecha y hora',
    reservationDuration: 'Duración',
    reservationRate: 'Por minuto',
    reservationLocation: 'Ubicación',
    reservationSubject: 'Tema',
    reservationQuotedTotal: 'Total presupuestado',
    reservationBilledDuration: 'Duración facturada',
    reservationSpentAmount: 'Importe pagado',
    reservationEarnedAmount: 'Importe ganado',
    reservationSettledAt: 'Liquidado',
    reservationCreated: 'Creada',
    reservationResponded: 'Respondida',
    reservationAcceptedAt: 'Aceptada',
    reservationDeclinedAt: 'Rechazada',
    reservationCancelledAt: 'Cancelada',
    reservationCancelledBy: 'Cancelada por',
    reservationYou: 'Tú',
    reservationCancellationNotification: 'Envío de la notificación',
    reservationNotificationPending: 'Preparando',
    reservationNotificationProviderAccepted: 'Aceptada por el proveedor de envío',
    reservationNotificationSuppressed: 'No enviada por las preferencias de notificación',
    reservationNotificationUnavailable: 'No se encontró ningún dispositivo apto',
    reservationPendingReschedule: 'Nueva hora propuesta',
    reservationNewTime: 'Nueva fecha y hora',
    proposeNewTime: 'Proponer otra hora',
    rescheduleFuture: 'La nueva hora debe estar en el futuro y diferir al menos un minuto de la hora de inicio programada actualmente.',
    reservationCallTooEarly: 'Esta llamada programada estará disponible 15 minutos antes de comenzar.',
    reservationCallExpired: 'La ventana de llamada de esta reserva ha finalizado.',
    reservationCallInProgress: 'La llamada vinculada a esta reserva ya ha comenzado.',
    reservationExecutionLocked: 'Esta llamada programada ya no se puede cambiar porque ha comenzado o finalizado.',
    openReservation: 'Abrir los detalles de la reserva con {name}',
    systemEventMeetupTitle: 'Encuentro con {name}',
    systemEventCallTitle: 'Llamada programada con {name}',
    systemEventNotes: 'Aceptado a través de nosubject.',
    systemCalendarCopyRemoved: 'Se eliminó la copia del calendario del sistema',
    restoreSystemCalendarCopy: 'Restaurar',
    systemCalendarRestoreFailed: 'No se pudo restaurar la copia del calendario. Revisa las conexiones y el permiso del sistema.',
    systemCalendarCopyChanged: 'Se cambió la hora del calendario del sistema',
    reviewSystemCalendarChange: 'Revisar',
    systemCalendarChangeTitle: 'Hora del calendario modificada',
    systemCalendarChangeBody: 'Este cambio no se aplicó a la otra persona.\n\nnosubject: {nosubject}\nCalendario del sistema: {system}',
    restoreNosubjectTime: 'Restaurar hora de nosubject',
    systemCalendarTimeRestoreFailed: 'No se pudo corregir la hora de la copia. Revisa las conexiones y el permiso del sistema.',
    proposeReschedule: 'Proponer a la otra persona',
    rescheduleSent: 'Nueva hora propuesta',
    rescheduleSentBody: 'Tu nueva hora se envió a {name}. La hora actual se mantiene hasta que la acepte.',
    rescheduleFailed: 'No se pudo proponer la nueva hora.',
    rescheduleActionFailed: 'No se pudo actualizar la propuesta de hora.',
    reschedulePendingReceived: 'Propuesta de nueva hora: {time}',
    reschedulePendingSent: 'Nueva hora pendiente de respuesta: {time}',
    withdrawReschedule: 'Retirar propuesta',
    rescheduleBubble: '📅 Se propuso una nueva hora de encuentro',
    rescheduleBubbleShort: '📅 Nueva hora de encuentro',
    connectionsTitle: 'Conexiones de calendario',
    connectionsInfo: 'Elige los calendarios que quieres ver',
    deviceCalendar: 'Calendarios del dispositivo',
    connect: 'Conectar',
    openSettings: 'Abrir ajustes',
    permissionGranted: 'Acceso concedido',
    permissionDenied: 'Acceso desactivado',
    permissionUnavailable: 'No disponible en esta versión',
    permissionNotRequested: 'Aún no conectado',
    devicePermissionInfo: 'El permiso se solicita solo cuando tocas este botón. nosubject lee únicamente los calendarios seleccionados y el intervalo necesario; no escribe eventos desde esta pantalla.',
    selectCalendars: 'Calendarios que se mostrarán',
    noDeviceCalendars: 'No hay calendarios de eventos disponibles en este dispositivo.',
    manageSystemPermission: 'Gestionar el permiso del calendario',
    connectionPrivacyInfo: 'La selección se guarda en este dispositivo para esta cuenta. Los detalles externos solo se usarán en tu vista y no se compartirán automáticamente.',
    newBuildRequired: 'Se necesita una versión más reciente para conectar calendarios.',
    connectionFailed: 'No se pudo conectar el calendario.',
    disconnect: 'Desconectar',
    disconnectTitle: '¿Desconectar el calendario?',
    disconnectBody: 'nosubject dejará de leer calendarios y de escribir nuevos eventos aceptados en este dispositivo. Se borran las selecciones y asociaciones locales; los eventos existentes del calendario del sistema permanecen. Puedes revocar el permiso del sistema por separado en los ajustes del dispositivo.',
    disconnectFailed: 'No se pudo desconectar el calendario.',
    selectionSaveFailed: 'No se pudo guardar la selección.',
    allDay: 'Todo el día',
    recurring: 'Recurrente',
    availabilityFree: 'Libre',
    availabilityBusy: 'Ocupado',
    availabilityTentative: 'Provisional',
    availabilityUnavailable: 'No disponible',
    untitledExternalEvent: 'Evento sin título',
    externalEventsFailed: 'No se pudieron cargar los eventos externos.',
    hideExternalEvent: 'Ocultar {title} de esta vista',
    hideExternalEventFailed: 'No se pudo ocultar el evento.',
    restoreHiddenExternalEvents: 'Volver a mostrar los eventos ocultos',
    restoreHiddenExternalEventsFailed: 'No se pudieron volver a mostrar los eventos ocultos.',
    hiddenExternalEventCount: '{count} eventos ocultos en este dispositivo',
    checkIncompleteTitle: 'Comprobación del calendario incompleta',
    checkIncompleteBody: 'No se pudo leer temporalmente al menos una fuente del calendario, por lo que no podemos confirmar que este horario esté totalmente libre. Puedes continuar si quieres.',
    conflictCheckIncomplete: 'No se pudieron leer algunos calendarios, así que podría haber más conflictos.',
    conflictTitle: 'Conflicto de calendario',
    reservationUnavailable: 'Este horario ya no está disponible debido a otra reserva confirmada.',
    reservationChanged: 'Esta reserva cambió en otra pantalla o dispositivo. Hemos cargado la versión más reciente.',
    reservationPast: 'No se puede aceptar una reserva cuya hora de inicio ya pasó.',
    conflictBody: 'Esta hora coincide con otro evento de tu calendario. Puedes continuar si lo deseas.',
    tentativeConflictTitle: 'Evento provisional del calendario',
    tentativeConflictBody: 'Hay un evento del calendario aún sin confirmar a esta hora. Revisa los detalles antes de continuar.',
    conflictMore: '• Otros eventos: {count}',
    continueAnyway: 'Continuar de todos modos',
    onlineCalendars: 'Calendarios en línea',
    googleCalendar: 'Google Calendar',
    providerConnected: 'Conectado',
    providerNotConnected: 'No conectado',
    providerUnavailable: 'La conexión oficial se está preparando',
    googlePrivacyInfo: 'Solo se sincronizan los calendarios que elijas. Los títulos y las ubicaciones se cifran en una caché mínima del servidor; no se guardan descripciones, asistentes ni enlaces de conferencia. nosubject no puede crear, cambiar ni eliminar eventos de Google Calendar.',
    googleConnectionFailed: 'No se pudo iniciar la conexión con Google Calendar.',
    microsoftCalendar: 'Calendario de Microsoft',
    microsoftInfo: 'nosubject solo lee tu disponibilidad (Calendars.Read). No puede crear, modificar ni eliminar eventos. El acceso se retira en la configuración de tu cuenta de Microsoft; nosubject no puede revocarlo por su cuenta.',
    microsoftConnectionFailed: 'No se pudo iniciar la conexión con el calendario de Microsoft.',
    googleDisconnectTitle: '¿Desconectar Google Calendar?',
    googleDisconnectBody: 'nosubject dejará de acceder a los datos de Google Calendar y revocará los permisos de Google que concediste a nosubject. Los eventos de Google Calendar no se eliminarán.',
    googleDisconnectFailed: 'No se pudo desconectar Google Calendar.',
    googleNoCalendars: 'No se encontraron calendarios de Google que se puedan leer.',
    googleSelectionSaveFailed: 'No se pudo guardar la selección de Google Calendar.',
  },
  instagram: {
    title: 'Conexión con Instagram',
    connectInfo: 'Conecta tu cuenta profesional con consentimiento explícito',
    connectedAccounts: 'Cuentas conectadas',
    professionalAccount: 'Cuenta profesional',
    connect: 'Conectar',
    reconnect: 'Volver a conectar',
    connectedAs: '@{username} · {accountType}',
    notConnected: 'Aún no está conectada',
    unavailable: 'La conexión oficial está en preparación',
    privacyInfo: 'La primera etapa solo solicita instagram_business_basic para leer la identidad de la cuenta profesional. No solicita permisos de mensajes, comentarios ni publicación, y no copia fotos a nosubject hasta que elijas importarlas por separado.',
    business: 'Empresa',
    creator: 'Creador',
    connectionFailed: 'No se pudo iniciar la conexión con Instagram.',
  },
  inbox: {
    markUnread: 'Marcar como no leído',
    markRead: 'Marcar como leído',
    archiveTitle: 'Archivo',
    archive: 'Archivo',
    failed: 'No se pudieron cargar las conversaciones',
    searchEmpty: 'Sin resultados',
    archivedEmpty: 'No hay conversaciones archivadas',
    empty: 'Aún no hay conversaciones',
    you: 'Tú:',
    archived: 'Archivada',
    unarchived: 'Desarchivada',
    undo: 'Deshacer',
    mute: 'Silenciar',
    muteTitle: 'Silenciar a {name}',
    mute1h: 'Durante 1 hora',
    mute8h: 'Durante 8 horas',
    mute1w: 'Durante 1 semana',
    muteForever: 'Sin límite de tiempo',
    unmute: 'Reactivar notificaciones',
    archiveAction: 'Archivar',
    unarchiveAction: 'Desarchivar',
    swipeRemove: 'Desarchivar',
    swipeArchive: 'Archivar',
    blockAction: 'Bloquear',
    blockTitle: '¿Bloquear a {name}?',
    blockMessage: 'Esta persona no podrá enviarte mensajes ni encontrarte en Descubrir.',
    blockConfirm: 'Bloquear',
  },
  // 9.33.9.3 / D-780 — passkeys, named as the system names them.
  passkeys: {
    // D-882 — signing in with a passkey.
    signIn: "Iniciar sesión con llave de acceso",
    signInIntro: "Con una llave de acceso puedes iniciar sesión sin tu número de teléfono ni un código.",
    signInNone: "Este dispositivo no tiene una llave de acceso para nosubject. Inicia sesión primero con tu número y luego añade una en Perfil → Ajustes → Métodos de inicio de sesión → Llaves de acceso.",
    signInFailed: "No se pudo iniciar sesión con tu llave de acceso. Inténtalo de nuevo.",
    // D-876 — a lost passkey, reset after a 48-hour wait.
    lost: "¿Perdiste tu llave de acceso?",
    recoveryIntro: "Si ninguno de tus dispositivos tiene ya tu llave de acceso, puedes restablecerla. Después de confirmar tu número, hay una espera de 48 horas. Te avisaremos en tu chat, y quien tenga tu llave de acceso puede cancelar el restablecimiento.",
    recoveryPending: "El restablecimiento estará listo el {date}.",
    recoveryCancel: "Cancelar restablecimiento",
    recoveryCancelled: "Restablecimiento cancelado.",
    recoveryReady: "El restablecimiento está listo. Añade tu nueva llave de acceso.",
    recoveryDone: "Se añadió tu nueva llave de acceso. Las anteriores ya no funcionan.",
    title: "Llaves de acceso",
    intro: "Una llave de acceso confirma que eres tú de la misma forma en que desbloqueas este dispositivo. Se queda en tu dispositivo; nosubject nunca recibe tu cara ni tu huella.",
    taskIntro: "Los mensajes que envías a la cuenta oficial de nosubject se confirman con una llave de acceso antes de enviarse.",
    empty: "Aún no tienes ninguna llave de acceso.",
    add: "Añadir una llave de acceso",
    remove: "Eliminar",
    removeTitle: "¿Eliminar esta llave de acceso?",
    removeBody: "Primero confirmarás con una llave de acceso.",
    added: "Llave de acceso añadida.",
    removed: "Llave de acceso eliminada.",
    addedOn: "Añadida el {date}",
    lastUsed: "Último uso: {date}",
    unnamed: "Llave de acceso",
    reauthIntro: "Para añadir tu primera llave de acceso, confirma tu número de teléfono registrado.",
    sendCode: "Enviar código de verificación",
    codeSent: "Se envió un código a tu número registrado terminado en {phone}.",
    codeLabel: "Código de verificación",
    startAgain: "Empezar de nuevo",
    wrongCode: "Ese código no funcionó. Pide uno nuevo.",
    failed: "No se pudo completar la solicitud. Inténtalo de nuevo.",
    exists: "Este dispositivo ya tiene una llave de acceso para tu cuenta.",
    unsupportedApp: "Esta versión de la app aún no puede usar llaves de acceso. Llegarán con la próxima actualización.",
    unsupportedWeb: "Este navegador no puede usar llaves de acceso.",
    tapTitle: "Continuar con tu llave de acceso",
    tapAction: "Continuar",
  },
  message: {
    info: "Información del mensaje",
    infoSentAt: "Enviado",
    infoReadAt: "Leído",
    infoPlatform: "Enviado desde",
    // 9.33.9.4 — a message to the task chat stopped for its passkey.
    passkeyNeededTitle: "Primero añade una llave de acceso",
    passkeyNeededBody: "Los mensajes a esta cuenta se confirman con una llave de acceso. Añade una y vuelve a enviar.",
    passkeyUnavailable: "Este mensaje necesita tu llave de acceso, que esta versión de la app aún no puede usar. Envíalo desde nosubject.co o después de la próxima actualización.",
    passkeyFailed: "No se pudo confirmar el mensaje, así que no se envió.",
    forwardOwn: "Reenviar",
    forwardHint: "Elige una conversación. El texto se abre como borrador; el envío y la confirmación del precio actual se realizan después.",
    forwardEmpty: "No hay otras conversaciones activas.",
    forwardDraftFirst: "Primero envía o borra tu borrador actual.",
    translationLanguage: "Idioma de traducción",
    chooseTranslationLanguage: "Elige un idioma de traducción",
    languageSuggestion: "Idioma sugerido del dispositivo",
    translationLanguageInfo: "Esta preferencia privada se aplica a las traducciones de todas tus conversaciones. No se añade a tu perfil.",
    photoCaption: "Añade un texto a la foto…",
    removePhoto: "Quitar foto",
    star: "Destacar mensaje",
    unstar: "Quitar destacado",
    starred: "Mensajes destacados",
    noStars: "No hay mensajes destacados en esta conversación.",
    starFailed: "No se pudieron actualizar los destacados. Inténtalo de nuevo.",
    starredAttachment: "Mensaje con archivo adjunto",
    edit: "Editar mensaje",
    edited: "Editado",
    editInfo: "Puedes editar hasta que se lea el mensaje, incluso sin confirmaciones de lectura. Si desaparece Editar, puede revelar que se leyó. No leído no significa no visto: el texto original pudo verse en una notificación. Editar no garantiza retirar lo dicho.",
    editFailed: "No se pudo confirmar la edición. El mensaje puede haberse leído o cambiado. Revisa el chat antes de volver a intentarlo.",
    copy: "Copiar",
    copyFailed: "No se pudo copiar el mensaje. Inténtalo de nuevo.",
    inputPlaceholder: 'Escribe un mensaje…',
    typing: 'Escribiendo',
    translate: 'Traducir',
    withdrawn: 'Mensaje retirado',
    linkOpenTitle: 'Abrir enlace',
    linkOpenBody: 'Esto te lleva a {host}. El enlace lo envió la persona que te escribe: ten cuidado si no la conoces.',
    linkOpenConfirm: 'Abrir',
    linkOpenFailed: 'No se pudo abrir el enlace.',
    seenAt: 'Visto {time}',

    priceChangedTitle: 'El precio cambió',
    priceChangedBody: 'Este mensaje ahora cuesta {new}, no {old}. ¿Enviarlo igual?',
    priceChangedSend: 'Enviar',
    priceNoticeTitle: 'Lo que cuesta hablar con esta persona',
    priceNoticeMessage: '{amount} por mensaje',
    priceNoticeCall: 'Llamadas {amount}',
    priceNoticePersonal: 'Estas tarifas se fijaron especialmente para ti.',
    priceDecreasedTitle: "El precio de los mensajes ha bajado",
    priceDecreasedBody: "Los mensajes ahora cuestan {new} en lugar de {old}. No hace falta confirmar el precio más bajo.",
    priceChange: {
      free: 'gratis',
    },
    expired: 'caducado, reembolsado',
    // 9.2 / D-650 — web'den gönderilen mesajın saat satırındaki notu.
    sentFromWeb: 'desde la web',
    linkViewLabel: 'Vista del enlace',
    linkViewPlain: 'Dirección simple',
    linkViewCompact: 'Compacto',
    linkViewCard: 'Tarjeta grande',
    linkPreviewLoading: 'Preparando la vista previa…',
    linkPreviewFailed: 'No se pudo obtener la vista previa de este enlace; se enviará como dirección simple.',
    linkPreviewA11y: 'Enlace: {title}, {host}',
    customPrice: 'Precio personalizado',
    priceUsesGeneral: 'Se aplica mi precio general',
    priceRemove: 'Quitar de contactos',
    priceRemoveTitle: '¿Quitar a {name} de tus contactos?',
    priceRemoveBody: 'El precio personalizado desaparece y {name} vuelve a tu precio general. Si solo tus contactos pueden escribirte, ya no podrá iniciar una conversación. Esto no es un bloqueo.',
    priceRemoveConfirm: 'Quitar',
    priceRemoved: '{name} vuelve a tu precio general.',
    pricePrompt: 'Precios para {name} (0 = gratis):',
    saved: 'Guardado',
    priceFreeSet: '{name} ahora puede escribirte gratis.',
    priceSet: 'Precio para {name} fijado en {price}.',
    saveError: 'No se pudo guardar.',
    photoError: 'No se pudo enviar la foto.',
    noConnection: 'Sin conexión',
    checkInternet: 'Revisa tu conexión a internet.',
    sendError: 'No se pudo enviar el mensaje.',
    addAttachment: 'Añadir archivo adjunto',
    sendMessageAction: 'Enviar mensaje',
    lowBalanceTitle: 'Saldo insuficiente',
    lowBalanceBody: 'Tu saldo no alcanza para enviar un mensaje a esta persona. Añade fondos e inténtalo de nuevo.',
    reply: 'Responder',
    reactionA11y: 'Reacción {emoji}, {count} en total',
    reactionA11yMine: 'Reacción {emoji}, {count} en total, incluida la tuya',
    reactionAdd: 'Reaccionar con {emoji}',
    moreReactions: 'Más emojis',
    reactionRemove: 'Quitar tu reacción {emoji}',
    you: 'Tú',
    photo: '📷 Foto',
    takePhoto: 'Tomar una foto',
    choosePhoto: 'Elegir de la galería',
    chooseVideo: 'Elegir un vídeo',
    recordVoice: 'Mensaje de voz',
    micPermissionTitle: 'Se necesita acceso al micrófono',
    micPermissionBody: 'Grabar un mensaje de voz requiere acceso al micrófono.',
    voiceError: 'No se pudo enviar el mensaje de voz',
    voiceRecording: 'Grabando',
    videoTooLarge: 'El vídeo es demasiado grande (máximo 1 GB)',
    videoTooLong: 'El vídeo es demasiado largo (máximo 10 minutos)',
    videoError: 'No se pudo enviar el vídeo',
    videoNeedsUpdate: 'Actualiza la app para ver este vídeo',
    voiceNeedsUpdate: 'Actualiza la app para escuchar este mensaje de voz',
    voiceOrderTitle: 'Mensaje de voz encargado',
    encrypted: 'Mensaje cifrado',
    identityChanged: 'La clave de seguridad de esta persona cambió. Suele significar un teléfono nuevo o una app reinstalada.',
    identityChangedVerify: 'Habías verificado este chat; vuelve a comparar el número de seguridad.',
    unencrypted: 'Este chat no está cifrado',
    unencryptedPeerInfo: 'La app de la otra persona todavía no admite el cifrado de extremo a extremo, así que lo que escribes aquí se envía sin cifrar y se puede leer en el servidor de nosubject. Cuando actualice su app, los mensajes nuevos se cifrarán automáticamente.',
    unencryptedOfficialInfo: 'Esta es la cuenta oficial de nosubject. Lo que escribes aquí se envía sin cifrar y el equipo de nosubject puede leerlo.',
    unencryptedSelfInfo: 'No se pudo activar el cifrado en este dispositivo (por ejemplo, una ventana privada del navegador no puede guardar claves). Lo que envías desde aquí va sin cifrar y se puede leer en el servidor de nosubject.',
    notificationOfferEnable: 'Activar notificaciones',
    notificationOfferEnabled: 'Las notificaciones están activadas',
    voiceOrderPending: 'Esperando la entrega',
    voiceOrderDelivered: 'Entregado',
    voiceOrderDeclined: 'Rechazado, reembolsado',
    voiceOrderExpired: 'Caducado, reembolsado',
    voiceOrderAction: 'Encargar un audio',
    voiceOrderPick: '¿De cuánto tiempo?',
    voiceOrderInsufficient: 'Tu saldo no alcanza para este encargo.',
    voiceOrderError: 'No se pudo hacer el encargo.',
    voiceOrderRecord: 'Grabar y enviar',
    voiceOrderDecline: 'Rechazar',
    voiceOrderDeclineTitle: 'Rechazar el encargo',
    voiceOrderDeclineBody: 'Todo el importe reservado vuelve a quien lo encargó.',
    voiceOrderDeclineError: 'No se pudo rechazar el encargo.',
    voiceOrderDeliverError: 'No se pudo entregar la grabación.',
    voiceOrderRecording: 'Grabación encargada',
    voiceOrderRemaining: 'Quedan {length}',
    voiceOrderShortNote: 'Si lo envías más corto, solo se paga lo que grabas.',
    voiceOrderRefunded: '{amount} devuelto',
    sendLocation: 'Enviar ubicación',
    locationTitle: 'Ubicación',
    locationError: 'No se pudo enviar la ubicación',
    shareLiveLocation: 'Compartir ubicación en vivo',
    liveLocationHour: '1 hora',
    liveLocationEightHours: '8 horas',
    liveLocationOpenEnded: 'Hasta que yo lo detenga',
    liveLocationSharing: 'Compartiendo tu ubicación en vivo',
    liveLocationStop: 'Detener',
    liveLocationError: 'No se pudo iniciar la ubicación en vivo',
    liveLocationCardTitle: 'Ubicación en vivo',
    liveLocationCardActive: 'Compartiendo ahora',
    liveLocationCardEnded: 'Compartir finalizado',
    liveLocationOpen: 'Ver ubicación',
    liveLocationNoPoint: 'Aún no hay posición',
    liveLocationOpenInMaps: 'Abrir en Mapas',
    locationMapError: 'No se pudo abrir el mapa.',
    liveLocationUpdatedAgo: 'Actualizado {ago}',
    videoShort: '🎬 Vídeo',
    voiceShort: '🎙 Mensaje de voz',
    liveLocationWatchedAgo: 'Visto hace {ago}',
    liveLocationNotWatched: 'Aún no lo ha visto',
    liveLocationSharerSeesYou: 'Puede ver cuándo lo miras',
    cameraPermissionTitle: 'Se necesita acceso a la cámara',
    cameraPermissionBody: 'Permite el acceso a la cámara para tomar una foto.',
    cameraError: 'No se pudo abrir la cámara.',
    photoLocationTitle: 'Ubicación de la foto',
    photoLocationPromptFile: '{place} se obtuvo del archivo de la foto. ¿Mostrar esta ubicación con la foto?',
    photoLocationPromptCapture: 'La ubicación del dispositivo indicó {place}. ¿Mostrar esta ubicación con la foto?',
    photoLocationHide: 'Enviar sin ubicación',
    photoLocationShare: 'Enviar con ubicación',
    photoLocationFromFile: 'Obtenido del archivo',
    photoLocationFromCapture: 'Ubicación del dispositivo',
    photoLocationHideAfter: 'Ocultar ubicación',
    photoLocationShowAfter: 'Mostrar ubicación',
    photoLocationUpdateError: 'No se pudo actualizar la ubicación de la foto.',
  },
  versionNotice: {
    title: 'Hay una versión nueva',
    body: 'Actualiza la app para tener mejoras de seguridad y funciones nuevas.',
    update: 'Actualizar',
  },
  notifications: {
    title: 'Notificaciones',
    cardBody: 'Activa las notificaciones del dispositivo para no perderte mensajes ni respuestas.',
    notNow: 'Ahora no',
    enable: 'Activar notificaciones',
    device: 'Notificaciones del dispositivo',
    stateOn: 'Activadas · Gestionar en ajustes',
    stateOff: 'Desactivadas · Activar en ajustes',
    stateAsk: 'Aún no se ha preguntado',
    preferences: 'Preferencias de notificación',
    preferencesInfo: 'Gestiona categorías, vistas previas y permiso del dispositivo',
    stateUnsupported: 'No compatible con este dispositivo',
    master: 'Todas las notificaciones',
    masterInfo: 'Si desactivas esta opción, dejarás de recibir todas las notificaciones push. Se conservan los ajustes de las categorías',
    categories: 'Categorías',
    categoryEnabled: 'Notificaciones de esta categoría',
    categoryEnabledInfo: 'Si desactivas esta opción, dejarás de recibir notificaciones push de esta categoría. Se conservan sus ajustes',
    events: 'Eventos',
    messages: 'Mensajes',
    messagesInfo: 'Mensajes nuevos y respuestas',
    meetups: 'Encuentros',
    meetupsInfo: 'Propuestas, cambios y resultados',
    meetupRequests: 'Nuevas propuestas de encuentro',
    meetupRequestsInfo: 'Cuando recibes una nueva propuesta de encuentro',
    meetupUpdates: 'Respuestas y cancelaciones',
    meetupUpdatesInfo: 'Cuando un encuentro se acepta, rechaza o cancela',
    meetupReminders: 'Recordatorios de encuentros',
    meetupRemindersInfo: 'Cuando se acerca un encuentro aceptado',
    calls: 'Llamadas',
    callsInfo: 'Llamadas entrantes, programadas y perdidas',
    incomingCalls: 'Llamadas entrantes',
    incomingCallsInfo: 'Una alerta sonora cuando alguien te llame',
    callRequests: 'Propuestas de llamada programada',
    callRequestsInfo: 'Cuando una propuesta se crea, acepta, rechaza o cancela',
    callReminders: 'Recordatorios de llamadas',
    callRemindersInfo: 'Cuando se acerca una llamada aceptada',
    missedCalls: 'Llamadas perdidas',
    missedCallsInfo: 'Cuando no pudiste responder una llamada',
    financial: 'Dinero y fondos en garantía',
    financialInfo: 'Cambios de estado de transacciones',
    financialEarnings: 'Ganancias y fondos en garantía',
    financialEarningsInfo: 'Cuando se liberan los fondos en garantía o hay ganancias disponibles',
    financialRefunds: 'Reembolsos y vencimiento',
    financialRefundsInfo: 'Cuando se reembolsa un pago o vencen los fondos en garantía',
    financialPayouts: 'Resultados de retiros',
    financialPayoutsInfo: 'Cuando una solicitud de retiro se completa o falla',
    reactions: 'Reacciones emoji',
    reactionsInfo: 'Reacciones a tus mensajes',
    official: 'De Nosubject',
    officialInfo: 'Avisos de Nosubject sobre versiones, seguridad y tu cuenta. Son independientes de tus otras notificaciones; si los desactivas, Nosubject no te envía notificaciones, pero sus mensajes siguen llegando a tu bandeja.',
    preview: 'Vista previa del mensaje',
    previewHidden: 'Oculta',
    previewHiddenInfo: 'No mostrar remitente ni mensaje',
    previewSender: 'Solo remitente',
    previewSenderInfo: 'Mostrar remitente y ocultar mensaje',
    previewText: 'Remitente y mensaje',
    previewTextInfo: 'Mostrar hasta 80 caracteres',
    deviceInfo: 'El permiso del sistema es específico de este dispositivo',
    openSettings: 'Abrir ajustes',
    centerTitle: 'Centro de notificaciones',
    centerMarkAll: 'Marcar todo como leído', centerMarkedAll: 'Todo marcado como leído',
    centerEmpty: 'Aún no hay notificaciones.',
    centerFailed: 'No se pudieron cargar las notificaciones.',
    centerMarkAllFailed: 'No se pudieron marcar como leídas.',
    centerUnknownPerson: 'Alguien',
    centerEscrowExpiredRefunded: 'Fondos en garantía vencidos · pago reembolsado',
    centerEscrowReleasedEarning: 'Respuesta completada · ganancias añadidas',
    centerMeetupRequest: '{name} te envió una propuesta de encuentro',
    centerCallRequest: '{name} te envió una propuesta de llamada programada',
    centerCallReminder: 'Tu llamada programada con {name} comenzará pronto',
    centerCallStarting: 'Tu llamada programada con {name} está empezando',
    centerMeetupStarting: 'Tu encuentro con {name} está empezando',
    centerMeetupReminder: 'Tu encuentro con {name} comenzará pronto',
    centerMeetupUpdate: '{name} · Encuentro: {status}',
    centerCallUpdate: '{name} · Llamada programada · Estado: {status}',
    centerMeetupRescheduleRequest: '{name} propuso una nueva hora de encuentro',
    centerCallRescheduleRequest: '{name} propuso una nueva hora de llamada',
    centerMeetupRescheduleUpdate: '{name} · Cambio de hora del encuentro: {status}',
    centerCallRescheduleUpdate: '{name} · Cambio de hora de la llamada: {status}',
    centerBell: 'Centro de notificaciones',
    centerBellUnread: 'Centro de notificaciones, sin leer: {count}',
  },
  profile: {
    viewPhoto: "Ver foto de perfil",
    photoUnavailable: "No se pudo cargar esta foto.",
    // 9.35.3 · D-830 — profile photos and videos.
    photos: "Fotos",
    mediaPhotoLabel: "Foto {n} de {total}",
    mediaVideoLabel: "Video {n} de {total}",
    mediaUnavailable: "No se pudieron cargar las fotos",
    mediaMore: "Mostrar más",
    // 9.35.4 · D-830 — removing one's own photo or video.
    mediaRemove: "Quitar del perfil",
    mediaRemovePhotoTitle: "¿Quitar esta foto de tu perfil?",
    mediaRemoveVideoTitle: "¿Quitar este video de tu perfil?",
    mediaRemoveBody: "El archivo se elimina y no se puede recuperar.",
    mediaRemoveFailed: "No se pudo quitar. Inténtalo de nuevo.",
    webVisibility: 'Quién puede ver mi página web',
    webVisibilityLink: 'Con el enlace',
    webVisibilityInfo: 'Tu perfil tal como lo ven las personas sin cuenta: tu página en nosubject.co/tu-usuario. Todos: tu página también puede aparecer en buscadores. Con el enlace: quien tenga la dirección puede abrirla; los buscadores no la muestran. Con cualquiera de las dos, las personas sin cuenta pueden acceder a los datos de tu perfil, incluida tu última conexión. Nadie: nadie sin cuenta puede ver tu perfil; la página dice “Este perfil no está disponible”. Tu perfil en la app no cambia. Salir de los resultados de búsqueda puede tardar unos días.',
    linkViewInfo: 'Elige cómo se envía un enlace que escribes. Con Compacto y Tarjeta grande, tu teléfono abre la página una vez y envía la vista previa con el mensaje; ese sitio ve la dirección IP de tu teléfono. En un chat cifrado, la vista previa va dentro del cifrado; en un chat sin cifrar, nosubject ve el enlace y la vista previa. Dirección simple no abre ninguna página. Los enlaces enviados desde la web siempre van como dirección simple.',
    linkViewAsk: 'Mostrar opciones al escribir',
    linkViewAskInfo: 'Si está activado, al escribir un enlace aparecen las otras dos vistas y puedes elegir una para ese mensaje. Si está desactivado, los enlaces siempre van con la vista que elijas aquí.',
    whoCanCallInfo: 'Elige quién puede llamarte; se aplica a cada llamada. Mis contactos son las personas a las que diste un precio personal. Con Excepciones puedes permitir o bloquear a personas una por una.',
    whoCanMessageInfo: 'Elige quién puede iniciar una conversación nueva contigo; las conversaciones ya iniciadas no cambian. Mis contactos son las personas a las que diste un precio personal. Con Excepciones puedes permitir o bloquear a personas una por una.',
    readReceiptsInfo: "Las confirmaciones se muestran solo si ambos las activan. Incluso desactivadas, la desaparición de Editar puede revelar que se leyó el mensaje.",
    showTypingInfo: 'Si está activado, la persona a la que escribes ve que estás escribiendo. Si lo desactivas, nadie lo ve, y tú sigues viendo cuándo escriben los demás.',
    officialAccount: 'Cuenta oficial',
    information: 'Información del perfil',
    logout: 'Cerrar sesión',
    account: 'Cuenta',
    accountData: 'Cuenta y datos',
    name: 'Nombre',
    surname: 'Apellido',
    username: 'Nombre de usuario',
    usernamePlaceholder: 'nombredeusuario',
    usernameChecking: 'Comprobando…',
    usernameAvailable: 'Disponible',
    usernameTaken: 'Este nombre de usuario ya está en uso',
    usernameInvalid: 'De 3 a 20 caracteres. Empieza por A–Z o a–z; después, usa A–Z, a–z, 0–9 o _.',
    usernameAdd: 'Añadir un nombre de usuario',
    profession: 'Profesión',
    professionNone: 'Sin profesión añadida',
    professionAdd: 'Añadir profesión',
    employer: 'Empresa',
    employerPlaceholder: 'usuariodelaempresa',
    employerInfo: 'Escribe un nombre de usuario existente en nosubject. Esta mención no significa que el empleo esté verificado.',
    employerNotFound: 'No se encontró ninguna cuenta activa con ese nombre de usuario.',
    employerSelf: 'No puedes indicar tu propia cuenta como empresa.',
    bio: 'Cuéntanos sobre ti…',
    prices: 'Precios',
    settings: 'Ajustes',
    priceMessage: 'Mensaje',
    priceVoice: 'Nota de voz (por minuto)',
    priceVoiceShort: 'Nota de voz',
    priceCall: 'Llamar ahora (por minuto)',
    priceCallShort: 'Llamar ahora',
    priceScheduledCall: 'Programar llamada (por minuto)',
    priceScheduledCallShort: 'Programar llamada',
    priceVideoCall: 'Videollamada',
    priceVideoCallShort: 'Vídeo',
    priceTime: 'Encuentro (por minuto)',
    priceTimeShort: 'Encuentro',
    currency: 'Moneda',
    saving: 'Guardando…',
    wallet: 'Cartera',
    chatBackup: 'Copia del chat',
    privacy: 'Privacidad',
    readReceipts: 'Confirmaciones de lectura',
    showTyping: 'Indicador de escritura',
    keepArchived: 'Mantener archivado',
    keepArchivedInfo: 'Si está desactivado, un mensaje nuevo desarchiva la conversación',
    whoCanMessage: 'Quién puede escribirme',
    whoCanCall: 'Quién puede llamarme',
    messagesFromContact: 'Mensajes de esta persona',
    callsFromContact: 'Llamadas de esta persona',
    callExceptions: 'Excepciones',
    callExceptionsEmpty: 'Aún no hay excepciones',
    messageExceptionsEmpty: 'Aún no hay excepciones para los mensajes',
    exceptionsLoadFailed: 'No se pudieron cargar las excepciones',
    openProfileHint: 'Abre el perfil de esta persona',
    callExceptionBlocked: 'Bloqueado',
    callsFromContactDefault: 'Predeterminado',
    callsFromContactAllow: 'Permitir siempre',
    callsFromContactBlock: 'Nunca',
    everyone: 'Todos',
    contacts: 'Mis contactos',
    nobody: 'Nadie',
    blockedUsers: 'Usuarios bloqueados',
    blockedEmpty: 'No has bloqueado a nadie',
    unblock: 'Desbloquear',
    appearance: 'Apariencia',
    light: 'Claro',
    dark: 'Oscuro',
    system: 'Sistema',
    displayLanguage: 'Idioma de la aplicación',
    education: 'Universidad',
    educationAdd: 'Añadir universidad',
    educationNone: 'Sin universidad añadida',

    educationLevel: 'Nivel de estudios',
    searchLanguage: 'Buscar idioma…',
    photoChange: 'Cambiar',
    saveFailed: 'No se pudo guardar.',
    photoFailed: 'No se pudo subir la foto.',
    photoChanged: "La foto cambió en otra operación o venció el plazo para reintentar. Selecciona la foto de nuevo.",
    deleteAccount: 'Eliminar cuenta',
    deleteTitle: 'Eliminar tu cuenta',
    deleteMessage: 'Tu cuenta se eliminará de forma permanente después de 30 días. Puedes volver a iniciar sesión durante este período para cancelarlo.',
    deleteMoneyWarning: 'Tienes {amount} entre tu cartera y los fondos en garantía. Te recomendamos retirarlo antes de eliminar la cuenta.',
    deleteConfirm: 'Eliminar',
    deleteFailed: 'No se pudo eliminar la cuenta.',
    deletionScheduled: 'Tu cuenta se eliminará el {date}.',
    deletionCancel: 'Cancelar eliminación',
    exportData: 'Descargar mis datos',
    exportFailed: 'No se pudieron obtener los datos.',
  },
  // Alt bar (dock) — ekran okuyucu etiketleri ve rozet sayıları (9.26.7.2.1)
  dock: {
    calls: 'Llamadas',
    discover: 'Descubrir',
    inbox: 'Mensajes',
    calendar: 'Calendario',
    profile: 'Perfil',
    unreadMessages: 'sin leer: {count}',
    pendingRequests: 'pendientes: {count}',
  },
  // 9.18.10.4 · D-830 — importing one's own Instagram download.
  instagramImport: {
    title: "Importar de Instagram",
    addEntry: "Importar de Instagram",
    guideIntro: "Descarga tus propios datos de Instagram y elígelos aquí para añadir tus fotos y videos a tu perfil.",
    guideStep1: "En Instagram, ve a Centro de cuentas → Tu información y permisos → Descargar tu información.",
    guideStep2: "En «Parte de tu información», elige solo Contenido; formato JSON, calidad multimedia Alta.",
    guideStep3: "Cuando Meta prepare el archivo, descárgalo y elígelo aquí.",
    guideOwnOnly: "Solo se muestran las fotos y videos que publicaste; nunca se toma el contenido de los mensajes.",
    guideOnDevice: "El archivo se abre en tu dispositivo y no se envía a nuestro servidor; solo se sube lo que elijas.",
    choose: "Elegir el archivo ZIP",
    reading: "Leyendo el archivo",
    notZip: "Este archivo no es un ZIP.",
    untrusted: "Este archivo no parece seguro y no se abrió.",
    tooBig: "Este archivo es demasiado grande.",
    unreadable: "No se pudo leer este archivo.",
    chooseAnother: "Elegir otro archivo",
    noMedia: "No se encontraron fotos ni videos que se puedan añadir en este archivo.",
    found: "{count} fotos y videos encontrados",
    slotsLeft: "Te quedan {count} espacios en el perfil",
    selectAll: "Seleccionar todo",
    selectNone: "Quitar selección",
    alreadyOnProfile: "En el perfil",
    tooLarge: "Demasiado grande",
    add: "Añadir {count}",
    adding: "Añadiendo {n} de {total}",
    stop: "Detener",
    stopping: "Se detendrá después de este",
    doneAdded: "{count} añadidos",
    doneDuplicate: "{count} ya estaban en tu perfil",
    doneSkipped: "{count} omitidos",
    doneFailed: "{count} no se pudieron añadir",
    retryFailed: "Volver a intentar los demás",
    profileFull: "Tu perfil está lleno; no se pudieron añadir más.",
    guideParts: "Si Meta dividió tu descarga en varias partes ZIP, elígelas todas juntas.",
    catAll: "Todo",
    catPosts: "Publicaciones",
    catReels: "Reels",
    catStories: "Historias",
    catIgtv: "IGTV",
    catArchived: "Archivadas",
    catProfile: "Fotos de perfil",
    catOther: "Otros",
    archiveSection: "Descarga de Instagram",
    archiveHint: "Añade a tu perfil las fotos y los videos de tu propia descarga de datos.",
  },
};
